module.exports = __webpack_public_path__ + "static/media/NiceToMeetYou.42c21349.png";